<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/8/2020
  -->

<template>
	<div class="form-view-root relative w-100">
		<div v-if="formItem && (isEditMode || formItem.isEnabled)">
			<div v-if="formItem.title" class="w-100 bold show-on-print-only text-center mb-4">
				{{formItem.title}}
			</div>
			<div v-if="isEditMode && !isEditable" class="card warning-background p-2 hide-on-print">
				<span v-if="formItem.getWorkflowTitle()">This form is a part of the {{formItem.getWorkflowTitle()}} and it can't be edited</span>
				<span v-else>This is a standard form and it can't be edited</span>
			</div>
			<div v-if="isEditMode" class="qwoach-form mb-2" :class="{'card': !formItem.isEnabled, 'danger-background': !formItem.isEnabled}">
				<div v-if="showFormEnableSwitch && isEditable" class="qw-row hide-on-print">
					<div class="layout-spacer"/>
					<FormSwitchRow
						:title="formItem.isEnabled ? 'Form is accepting responses' : 'Form is disabled'"
						:forceVerticalOnMobile="false"
						v-model="formItem.isEnabled"
						@change="updateFormItem"
					/>
					<ToolTipView class="px-2">
						<div v-if="formItem.isEnabled">
							This form is enabled and is accepting responses.
						</div>
						<div v-else>
							This form is disable and doesn't accept new responses.
						</div>
					</ToolTipView>
				</div>

<!--				<FormTextRow-->
<!--					v-if="!formItem.isEnabled"-->
<!--					class="mb-4 px-4"-->
<!--					title="Message for respondents"-->
<!--					:placeholder="defaultDisabledMessage"-->
<!--					:isVertical="true"-->
<!--					@blur="disabledMessageChangeDebouncer.onChangeImmediate()"-->
<!--					@change="disabledMessageChangeDebouncer.onChangeDebounced()"-->
<!--					v-model="formItem.disabledMessage"-->
<!--				/>-->
			</div>
<!--			<div class="qw-row">-->
<!--				<div class="layout-spacer"/>-->
<!--				<FormSwitchRow-->
<!--					title="This is an intake form"-->
<!--					v-model="formItem.isIntakeForm"-->
<!--					@change="updateFormItem"-->
<!--				/>-->
<!--				<ToolTipView class="px-2">-->
<!--					If switched on, responses of this form will also show up under client's profile in the "details" section.-->
<!--				</ToolTipView>-->
<!--			</div>-->
			<div class="row mx-0 mb-5">
				<div class="col px-0"
					 :class="{'is-edit': isEditMode}"
					 @mouseup="clearFormValidation()">
					<slot v-if="formElements.length > 0" name="title"/>

					<div v-if="showQuestionSwitchers" class="mx-2 text-center my-2">
						<div class="w-100 qw-col justify-content-center ">
							<el-progress class="w-50" :percentage="Math.trunc(currentQuestionIndex / formElements.length * 100)" />
						</div>
						<div>({{currentQuestionIndex + 1}} out of {{formElements.length}})</div>
					</div>
					<div :class="{'qw-row': showQuestionSwitchers}">

						<div v-if="showQuestionSwitchers" class="mx-3">
							<qw-button-icon
								v-if="!isFirstQuestion"
								:primary="true"
								circleSize="2.4em"
								icon="icon-left-open-big"
								@click="currentQuestionIndex--"/>
						</div>

						<el-form :model="formItem"
								 label-position="right"
								 ref="mainForm"
								 backgroundColor="#409EFF"
								 class="pb-4 col px-0 qwoach-form"
								 @submit.prevent="">

							<div v-if="isEditMode && formItem.settings.collectNameAndEmailAfterSubmit"
								 class="py-4">
								<span class="title-1">Name and Email will be collected at the end before completing this form.
								</span>
								<ToolTipView></ToolTipView>
								<ToolTipView>
									Name and email won't be collected if they were submitted before, for example if it's an existing client

									<div v-if="formItem.isEditable">
										<br/>
										To change this setting, go to settings and deselect 'Collect name and email after submit' option.
									</div>
								</ToolTipView>
							</div>


							<draggable v-model="formElementsToDisplay"
									   itemKey="id"
									   handle=".drag-handle"
									   ghost-class="ghost"
									   @end="onDragFinished">
								<template #item="{element: formElement}">
									<div class="mb-3">

										<component
											:is="componentNameFromType(formElement.type, formElement)"
											:prop="'formElements.' + formElement._index + '.answer'"
											:rules="getRules(formElement)"
											:formElement="formElement"
											:disabledTypes="disabledTypesComputed"
											:formItem="formItem"
											:viewMode="viewMode"
											:isEditable="isEditable"
											@copy="onCopyClicked"
											@delete="onDeleteClicked"
											@selected="onElementSelected"
											@change="onElementChanged"
											@typeChanged="onTypeChanged"
											@descriptionVisibilityToggle="descriptionVisibilityToggle"/>

										<div v-if="isEditable && isEditMode && (formElement._isSelected || formElement._index === formElements.length - 1)" class="text-center my-3">
											<qw-button class="hide-on-print" type="primary" @click="createQuestionElement(formElement._index)" @keypress.enter.prevent>+ Add Question</qw-button>
										</div>
									</div>

								</template>
	<!--							<div v-for="(formElement, index) in formElements"-->
	<!--								 :key="index"-->
	<!--								 class="mb-3">-->


	<!--							</div>-->

							</draggable>

						</el-form>

						<div v-if="showQuestionSwitchers" class="mx-3">
							<qw-button-icon
								v-if="!isLastQuestion"
								:primary="true"
								backgroundColor="#409EFF"
								circleSize="2.4em"
								icon="icon-right-open-big"
								@click="onNextQuestionClicked"/>
						</div>
					</div>

					<!--					<div v-if="isEditMode && this.formItem && !this.formItem.hasSelectedElements()" class="text-center mb-5">-->
<!--						<qw-button type="primary" size="normal" @click="createQuestionElement()">+ Add Question</qw-button>-->
<!--					</div>-->
				</div>
<!--				<div v-if="isEditMode" class="pl-4" style="min-width: 72px;">-->
<!--					<div v-sticky sticky-offset="{top: 10}">-->
<!--						<FormMenu-->
<!--							@click="menuItemClicked"/>-->
<!--					</div>-->
<!--				</div>-->
			</div>
			<slot name="submit">
				<div v-if="canShowSubmitButton" class="row mx-0 justify-content-center">
					<el-button v-if="isAnswerMode"
							   type="primary"
							   style="width: 200px"
							   @click="submitFormAnswer()">
						{{ submitButtonText }}
					</el-button>
				</div>
			</slot>
		</div>

		<div v-else-if="!isProgressShowing && showEmptyView" class="text-center row align-items-center" style="height: 90vh">
			<div class="col" v-if="formItem">
				<h1>{{emptyText}}</h1>
			</div>
			<div class="col" v-else>
				<h1>This form is no longer available.</h1>
				<h5>If you believe this is an error, please contact your coach directly</h5>
			</div>
		</div>
        <LoadingIndicator v-if="!hideLoading" class="center-fixed"/>
	</div>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue"
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import FormElementTitle from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/FormElementTitle";
import FormElementTitleView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTitleView.vue";
import FormElementTextView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTextView.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import FormMenu from "@/core/modules/coach/Resources/Forms/FormMenu.vue";
import {plainToClass} from "class-transformer";
import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog";
import FormItem from "@/core/modules/coach/Resources/Forms/model/FormItem";
import FormElementCheckboxesView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementCheckboxesView.vue";
import {ViewModeEnum} from "@/utils/helpers";
import FormElementRadioView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementRadioView.vue";
import draggable from "vuedraggable";
import {FormSpecialFieldEnum} from "@/core/modules/coach/Resources/Forms/model/SpecialFieldEnum";
import QwInput from "@/core/components/Controls/QwInput.vue";
import FormCheckboxRow from "@/core/components/Form/FormCheckboxRow.vue";
import FormSwitchRow from "@/core/components/Form/FormSwitchRow.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import Debouncer from "@shared/Debouncer";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import {classToClass} from "@qwoach/class-transformer-wrapper";
import FormElementFooterView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementFooterView.vue";
import FormElementRadioButtons from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementRadioButtons";
import FormElementScoreResultView
	from "@/core/modules/coach/Resources/Forms/FormElements/FormElementScoreResultView.vue";
import FormElementDateView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementDateView.vue";
import FormElementContactInfoView
	from "@/core/modules/coach/Resources/Forms/FormElements/FormElementContactInfoView.vue";
import FormElementAddressView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementAddressView.vue";
import FormElementTextGridView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTextGridView.vue";
import {getPredefinedFormById} from "@/core/modules/coach/Resources/Forms/model/PredefinedForms.js";
import {pickClientSimpleDialog} from "@/core/components/Picker/ClientPickerView/dialog.js";

export default {
	name: "FormView",
	components: {
		FormElementTextGridView,
		FormElementAddressView,
		FormElementContactInfoView,
		FormElementDateView,
		FormElementScoreResultView,
		FormElementFooterView,
		ToolTipView,
		FormTextRow,
		FormSwitchRow,
		FormCheckboxRow,
		QwInput,
		FormElementRadioView,
		FormElementCheckboxesView, FormMenu, LoadingIndicator, FormElementTextView, FormElementTitleView,
		draggable
	},
	extends: BaseVModelView,

	// formItem field can be passed directly as v-model
	// and is stored in valueData
	props: {
		formId: String,
		coachId: {String, required: true},
		viewMode: {type: String, default: "EDIT"},
		showSubmitButton: {type: Boolean, default: false},
		showEmptyView: {type: Boolean, default: false},
		submitButtonText: {type: String, default: "Submit"},
		hideNameAndEmail: {Boolean, default: false},
		tooltipAnalyticsProps: Object,
		hideLoading: Boolean,
		showFormEnableSwitch:{type: Boolean, default: true},
		journalEntryId: String,
		disableSave: Boolean,
        disableNotification: Boolean,
		teamMemberId: String, //TODO finish adding team member id to form view answers

	},

	watch: {
		formId: {
			immediate: false,
			handler() {
				this.onFormIdChanged()
			}
		}
	},


	data() {
		return {
			notAcceptingResponsesClasses:["bg-danger", "text-white", "rounded"],
			disabledMessageChangeDebouncer: null,
			updateFormItemDebouncer: null,
			currentQuestionIndex: 0,
		}
	},

	created() {

		console.log("FormView.created: formId = ", this.formId, ", form = ", this.formItem)

		this.updateFormItemDebouncer = new Debouncer(this._updateFormItemInternal.bind(this), 500)
		this.disabledMessageChangeDebouncer = new Debouncer(this.updateFormItem.bind(this), 1000)
	},

	mounted(){
		console.log("FormView.mounted: formId = ", this.formId, ", form = ", this.formItem)
		this.onFormIdChanged()
	},

	methods: {

		onFormIdChanged(){
			console.log("FormView.onFormIdChanged formId = ", this.formId, ", form = ", this.value)
			if (this.formItem) {
				this.onFormLoaded()
			} else if (this.formId) {
				this.loadFormItem()
			} else {
				this.onFormLoaded()
			}
		},

		async onNextQuestionClicked(){
			if(await this.validateFormRes()){
				this.currentQuestionIndex++
			}
		},

		onValueChanged(){
			this.selectFirstVisibleElement()
		},

		onDisabledMessageChanged(){
			this.updateFormItem()
		},

		setFullName(fullName){
			console.log("setFullName: fullName = ", fullName, ", this.formItem = ", this.formItem)
			if(this.formItem){
				this.formItem.setFullName(fullName)
			}
		},

		fillInSmartFieldsFromClientProfile(clientProfile){
			if(this.formItem){
				this.formItem.fillInSmartFieldsFromClientProfile(clientProfile)
			}
		},

		setClientId(clientId){
			if(this.formItem){
				this.formItem.setClientId(clientId)
			}
		},


		setEmail(email){
			if(this.formItem){
				this.formItem.setEmail(email)
			}
		},


		async getFormAnswer(){
			return await this.validateFormAnswer()
		},

		setFormItem(formItem){
			this.formItem = formItem
		},
		getFormItem(){
			return this.formItem
		},

		//public method
		async submitFormAnswer(disableNotification) {
            disableNotification = disableNotification || this.disableNotification
			let formItem = await this.validateFormAnswer()
			console.log("submitFormAnswer: formItem = ", formItem)
			if (!formItem || !formItem.isEnabled) {
				return
			}
			if(!formItem.clientId && formItem.settings.collectNameAndEmailAfterSubmit){
				let clientProfile = await pickClientSimpleDialog({
					title: "Contact details",
					okTitle: "Submit",
					isOwnedByClient: true,
					// additionalInfo: this.wheelItem.additionalInfo,
					additionalMessage: "Where should we send you the detailed results?"
				})
				if(!clientProfile){
					return
				}
				formItem.setFullName(clientProfile.name)
				formItem.setEmail(clientProfile.email)
			}
			try {
				if(this.showSubmitButton){
					this.progressDataLoading("Submitting...")
				}
				let formItem = await this.$dataManager.apiPostFormAnswersSubmit({
					coachId: this.coachIdComputed,
					formItem: this.formItem,
					journalEntryId: this.journalEntryId,
					disableNotification: disableNotification,
					teamMemberId: this.teamMemberId,
				})
				formItem.recalculateScore()
				await this.setDeviceClientId(formItem.clientId)
				this.hideProgress()
				this.$emit('submitted', formItem)
				return formItem
			} catch (error) {
				this.handleError(error)
			}
		},

		isFormEnabled(){
			return this.formItem && this.formItem.isEnabled
		},

		async validateFormAnswer() {
			console.log("validateFormAnswer")
			if(this.formItem && this.formItem.isEnabled){
				console.log("validateFormAnswer started")
				return await this.submitForm()
			}
		},


		getRules(formElement) {
			let validator
			let message
			// if(formElement.id === FormSpecialFieldEnum.EMAIL){
			// 	validator = formEmailValidator
			// } else {
				message = 'This question is required'
			// }
			let defaultValidationRule = {
				required: formElement.isRequired && !formElement.isTypeTitleOrFooter(),
				message,
				trigger: 'validate'
			}

			return formElement.getValidateRules() || defaultValidationRule
		},

		onFormFailed() {
			if (this.showSubmitButton) {
				this.toastWarn("Some required fields are not set.")
			}
		},

		async onFormValidated() {
			try {
				this.formItem.createdAt = new Date().getTime()
				this.progressDataLoading("Submitting...")
				this.$emit("onSubmit", this.formItem, this)
				this.hideProgress()
				return this.formItem
			} catch (error) {
				this.handleError(error)
			}
		},


		menuItemClicked(command) {
			console.log("command = ", command)
			switch (command) {
				case "question":
					return this.createQuestionElement()
				case "title":
					return this.createTitleElement()
				case "import":
					return this.importForm()
				case "save":
					return this.onFormSavePressed()
			}
		},

		findIndexToInsertElement(formElement) {
			for (let i = 0; i < this.formItem.formElements.length; ++i) {
				let element = this.formItem.formElements[i]
				if (formElement) {
					if (formElement.id === element.id) {
						return i
					}
				} else {
					if (element._isSelected) {
						return i
					}
				}
			}
			return this.formItem.formElements.length - 1
		},

		async onDragFinished() {
			await this.updateFormItem()
		},

		async createQuestionElement(index) {
			index = index || this.formItem.formElements.length - 1
			let formElement = new FormElementRadioButtons()
			let prevElement = this.formItem.formElements[index]
			formElement.fillOptionsFrom(prevElement)
			formElement.isRequired = prevElement.isRequired
			await this.insertFormElement(formElement, index)
		},

		async createTitleElement() {
			let formElement = new FormElementTitle()
			await this.insertFormElement(formElement)
		},

		async importForm(){

		},

		async onFormSavePressed(){
			//	Following auto save UX best practice, we keep a dummy save button
			//	so user feels in control.
			this.toast("Form saved")
		},

		async updateFormItem() {
			if(!this.isEditMode){
				return
			}
			this.updateFormItemDebouncer.onChangeDebounced()
		},

		async _updateFormItemInternal(){
			if(this.disableSave){
				console.log("save is disabled. Skipping form update.")
				return
			}
			let res = await this.handleAsyncNonBlocking(this.$dataManager.updateFormItem(this.formItem))
			if(res){
				// this.toast("Changes saved successfully")
				this.notifyValueChanged()
			}
		},

		async loadFormItem() {
			console.log("FormView.loadFormItem: formId = ", this.formId, ", coachId = ", this.coachIdComputed)
			let predefinedForm = getPredefinedFormById(this.formId)
			let formRequestParams = {coachId: this.coachIdComputed, formId: this.formId}
			this.formItem = predefinedForm || await this.handleAsync(() => this.$dataManager.apiGetFormItemPublic(formRequestParams), {defaultValue: null})
			if(predefinedForm){
				let {settings} = await this.handleAsync(() => this.$dataManager.apiGetFormItemPublic(formRequestParams), {defaultValue: {}})
				if(settings){
					this.formItem.applySettings(settings)
				}
			}

			this.selectFirstVisibleElement()
			console.log("loadFormItem: this.formItem = ", this.formItem)
			this.onFormLoaded()
		},

		onFormLoaded(){
			this.$emit("formLoaded", this.formItem)
		},

		selectFirstVisibleElement(){
			console.log("FormView.selectFirstVisibleElement = ", this.isEditMode, this.formItem)

			if(this.formItem && this.isEditMode && !this.formItem.hasSelectedElements()){
				this.formItem.selectFirstVisibleQuestion()
			}
		},

		clearSelection(){
			if(this.formItem){
				this.formItem.clearSelection()
			}
		},

		componentNameFromType(formElementType, formElement) {
			switch (formElementType) {
				case FormElementType.SCORE_RESULT:
					return "FormElementScoreResultView"
				case FormElementType.TITLE:
					return "FormElementTitleView"
				case FormElementType.FOOTER:
					return "FormElementFooterView"
				case FormElementType.DATE:
				case FormElementType.DATE_OF_BIRTH:
					return "FormElementDateView"
				case FormElementType.PHONE_NUMBER:
					return "FormElementTextView" //TODO create dedicate element for phone number to collect primary phone number and optionally a secondary phone number
				case FormElementType.ADDRESS:
					return "FormElementAddressView"
				case FormElementType.EMERGENCY_CONTACTS:
				case FormElementType.CONTACT_INFO:
					return "FormElementContactInfoView"
				case FormElementType.TEXT_GRID:
					return "FormElementTextGridView"
				case FormElementType.EMAIL_ADDRESS:
				case FormElementType.FULL_NAME:
				case FormElementType.TEXT:
				case FormElementType.MULTILINE:
					return "FormElementTextView"
				case FormElementType.RADIOBUTTONS:
					return "FormElementRadioView"
				case FormElementType.CHECKBOXES:
					return "FormElementCheckboxesView"
			}
		},

		async insertFormElement(formElement, index) {
			index = index || this.formItem.formElements.length - 1//this.findIndexToInsertElement()
			this.formItem.addElement(formElement, index + 1)
			this.onElementSelected(formElement)
			console.log("insertFormElement: index = ", index, ", formElement = ", formElement, ", ")
			await this.updateFormItem()
		},

		async onCopyClicked(formElement) {
			let index = this.findIndexToInsertElement(formElement)
			let copy = classToClass(formElement)
			copy.id = this.$dataManager.generateId()
			await this.insertFormElement(copy, index)
			this.toast("Copied successfully")
		},
		async onDeleteClicked(formElement) {
			let itemName = "question"
			if(formElement.type === FormElementType.FOOTER){
				itemName = "footer"
			}
			if(formElement.type === FormElementType.TITLE){
				itemName = "title"
			}
			let shouldDelete = await deleteConfirmDialog({itemName: itemName})
			if (shouldDelete) {
				this.formItem.deleteElement(formElement)
				// let index = this.findIndexToInsertElement(formElement)
				// this.formItem.formElements.splice(index, 1);
				await this.updateFormItem()
			}
		},

		onElementSelected(formElement) {
			console.log("onElementSelected: formElement = ", formElement)
			this.formElements.forEach(element => element._isSelected = false)
			// if(!formElement.isFullNameItem() && !formElement.isEmailItem()){
				formElement._isSelected = true
			// }
		},

		async onElementChanged(formElement) {
			switch (formElement.type){
				case FormSpecialFieldEnum.FULL_NAME:
					this.formItem.clientName = formElement.answer
					break;
				case FormSpecialFieldEnum.EMAIL:
					this.formItem.clientEmail = formElement.answer
					break;
			}
			await this.updateFormItem()
			console.log("onElementChanged: formElement = ", formElement)
		},

		async onTypeChanged(formElement) {
			let index = formElement._index
			// this will recreate the formItem with the correct updated type of the formElement
			// IMPORTANT!! it must be stringify/parse and not classToClass or classToPlain/plainToClass
			// otherwise class-transform loses "type" field and it can't recreate the class correctly

			let plain = JSON.parse(JSON.stringify(this.formItem))
			this.formItem = plainToClass(FormItem, plain)

			this.formItem.formElements[index].resetElement()
			this.formItem.syncSettingsFromFormElements()

			await this.onElementChanged(formElement)
		},
		async descriptionVisibilityToggle(formElement) {
			formElement.showDescription = !formElement.showDescription
			await this.onElementChanged(formElement)
		}

	},

	computed: {
		formItem: {
			get: function () {
				return this.valueData
			},
			set: function (valueData) {
				console.trace("FormView.formItem.set: valueData = ", valueData)
				this.valueData = valueData
				this.selectFirstVisibleElement()
				this.notifyValueChanged()
			},
		},

		isEditMode() {
			return this.viewMode === ViewModeEnum.EDIT
		},
		isViewMode() {
			return this.viewMode === ViewModeEnum.VIEW
		},
		isAnswerMode() {
			return this.viewMode === ViewModeEnum.ANSWER
		},
		formElements() {
			console.log("formElements: recalculating")
			console.log("formElements: this.hideNameAndEmail = ", this.hideNameAndEmail)
			console.log("formElements: this.formItem = ", this.formItem)
			let res = []
			if(!this.formItem){
				return res
			}
			res = this.formItem.formElements
			let index = 0
			res.forEach(element => {
				element._index = index
				index++
			})
			if(this.hideNameAndEmail){
				res = res.filter(item => item.type !== FormSpecialFieldEnum.EMAIL && item.type !== FormSpecialFieldEnum.FULL_NAME)
			}
			if(this.isAnswerMode){
				res = res.filter(item => item.type !== FormElementType.SCORE_RESULT)
			}
			if(this.formItem.settings.collectNameAndEmailAfterSubmit){
				res = res.filter(item => item.type !== FormSpecialFieldEnum.EMAIL && item.type !== FormSpecialFieldEnum.FULL_NAME)
			}

			return res
		},

		formElementsToDisplay(){
			let res = this.formElements
			if(this.isAnswerMode && this.formItem.settings.showSingleQuestionPerPage){
				res = [res[this.currentQuestionIndex]]
			}

			return res
		},

		canShowSubmitButton(){
			return this.showSubmitButton && (!this.isSingleQuestionPerPage || this.isLastQuestion)
		},

		showQuestionSwitchers(){
			return this.isSingleQuestionPerPage && this.isAnswerMode
		},
		isSingleQuestionPerPage(){
			return this.formItem.settings.showSingleQuestionPerPage
		},

		isLastQuestion(){
			return this.currentQuestionIndex >= this.formElements.length - 1
		},
		isFirstQuestion(){
			return this.currentQuestionIndex <= 0
		},

		defaultDisabledMessage(){
			return FormItem.defaultDisabledMessage()
		},

		emptyText(){
			let text = this.formItem ? this.formItem.disabledMessage : ""
			return text || this.defaultDisabledMessage;
		},

		coachIdComputed(){
			return this.coachId || this.$authManager.getCoachId()
		},

		isEditable(){
			return this.formItem.isEditable
		},

		disabledTypesComputed(){
			if(this.formItem.settings.collectNameAndEmailAfterSubmit){
				return [
					FormSpecialFieldEnum.EMAIL,
					FormSpecialFieldEnum.FULL_NAME
				]
			}
			return []
		},
	}
}
</script>

<style lang="scss">

.form-view-root {
	position: relative;
	.form-padding {
		padding: 0;
	}

	.is-edit {
		.el-form-item {
			margin-bottom: 0;
		}
	}

	.text-white {
		.form-subtitle{
			color: white;
		}
	}
}

</style>
